const SHAPE_CODES = {
  none: 0,
  square: 0, // The built-in square is stored as a 1:1 video without an AR image mask.
  circle: 1,
  capsule: 2,
  hexagon: 3,
  rounded_rect: 4,
  star: 5,
  custom_template: 6,
};

export function getVideoShapeCode(value) {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && /^\d+$/.test(value.trim())) return Number(value.trim());
  return SHAPE_CODES[value] ?? null;
}

export function isSquareVideoShape(value, details) {
  return String(value).toLowerCase() === "square" ||
    [details?.shapeName, details?.name, details?.maskLabel, details?.label]
      .some((name) => typeof name === "string" && name.trim().toLowerCase() === "square");
}

export function getSquareVideoFrameStyle(value, details) {
  if (!isSquareVideoShape(value, details)) return undefined;
  return {
    aspectRatio: "1 / 1",
    height: "auto",
    maxHeight: "none",
    borderRadius: 0,
    overflow: "hidden",
    clipPath: "inset(0)",
    "& video": { objectFit: "cover", borderRadius: 0 },
  };
}

// Older built-in Square mappings have shape 0. Their encoded dimensions retain
// the square geometry, so restore the frame when the video metadata is available.
export function fitSquareVideoPreview(event, value, details) {
  const video = event.currentTarget;
  const unmasked = getVideoShapeCode(value) === 0 || value == null;
  const squareVideo = video.videoWidth > 0 && video.videoWidth === video.videoHeight;
  if (!isSquareVideoShape(value, details) && !(unmasked && squareVideo)) return;
  const frame = video.parentElement;
  if (!frame) return;
  Object.assign(frame.style, {
    aspectRatio: "1 / 1", height: "auto", maxHeight: "none",
    borderRadius: "0", overflow: "hidden", clipPath: "inset(0)",
  });
  Object.assign(video.style, { objectFit: "cover", borderRadius: "0" });
}
